import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localeEn = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  LABEL_FOOTER_TEXT_SHORTER: 'Data privacy and terms of use.',
  LABEL_HANA_WIDGET_BANNER_CATEGORIES_TITLE: 'You can also consult these frequent topics:',
  LABEL_HANA_WIDGET_VIEW_HISTORY_BUTTON: 'View history',
  MAIN_CHAT_LABEL_PLACEHOLDER_TEXTAREA: 'Write the query you want to perform',
  LABEL_CATEGORIES: 'Categories',
  LABEL_FILTER_TITLE: 'Select an option to get suggestions for related queries',
  LABEL_HANA_ERROR_FETCH_TITLE: 'Error loading data',
  LABEL_HANA_ERROR_FETCH_DESCRIPTION: 'Could not load data',
  LABEL_HANA_ERROR_FETCH_BUTTON: 'Retry'
});
export default localeEn;